import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'

export const useConversationCardStyles = makeStyles(theme => ({
  card: {
    backgroundColor: GRAY_COLORS[50],
    borderRadius: 12
  },
  label: {
    color: PRIMARY_COLORS[700],
    fontSize: 24,
    fontWeight: 600,
    marginBottom: 4,
    textAlign: 'center'
  },
  description: {
    fontWeight: 500,
    fontSize: 12,
    textAlign: 'center'
  }
}))
